// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import * as types from './store/mutation-types'
import store from './store'
import Mint from 'mint-ui'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
import filters from './filters'
import VueClipboard from 'vue-clipboard2'
import VueWechatTitle from 'vue-wechat-title'
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import { errorFormatter } from '@/util/util.js'
import VConsole from 'vconsole'

import rfLayout from './components/base/rf_layout'
import rfText from './components/base/rf_Text'
import rfFlex from './components/base/rf_flex'
import rfIcon from './components/base/rf_Icon'
import rfPrice from './components/base/rf_price'
import moment from 'moment'
import xss from 'xss'
Vue.prototype.xss = xss
moment.locale('zh-CN')
// const $wx = window.wx
/**
 * 旧二维码扫码的跳转规则
 * http://store.zizai.test.thinkinpower.net/index.html?communityId=1      小富市集活动--url来源：社区后台-小富市集-社区链接 (rfFair url中获取 communityId，点击事件将item.serviceId存sessionStorge, 方便后续跳店铺，商品详情)
 * http://store.zizai.test.thinkinpower.net/index.html?rfActivityId=1163   拎包入住/自在驿站活动--url来源：平台后台-活动管理-活动链接 (rfActivity 初始化获取页面详情接口获取communityId存serviceId存sessionStorge， 点击事件将item.serviceId存sessionStorge, 方便后续跳店铺，商品详情)
 * http://store.zizai.test.thinkinpower.net/index.html?serviceId=413&goodsDetail=352&communityId=1 商品详情页--url来源：商家中心-模板后台-商品管理-上架状态-二维码
 * http://store.zizai.test.thinkinpower.net/index.html?serviceId=413&communityId=4 店铺首页--url来源：商家中心-服务管理-我的服务-上架状态-二维码
 * http://t.open.zizai.rfmember.net//static/jump.html?serviceId=894&communityId=1 第三方开发接入服务--url来源：商家中心-服务管理-我的服务-上架状态-二维码
 * http://localhost:8093/index.html?serviceId=413&goodsDetail=323#/goodsDetail/323 开发链接--商品详情
 * WAP 指新APP版本， APP 指旧APP 版本
 * serviceId: 吴 891,绿灯 413,全家便利店 415, 棉花糖 923, 喜洋洋 820, 恒源 423, Tanson便利店 1133
 */
/**
 * 新二维码跳转
 * http://store.zizai.thinkinpower.com/#/market?isNew=1&communityId=1 生产
 * https://zizai-life.test.thinkinpower.net/store/#/rfFair?isNew=1&communityId=1      小富市集活动--url来源：社区后台-小富市集-社区链接 (rfFair url中获取 communityId，点击事件将item.serviceId存sessionStorge, 方便后续跳店铺，商品详情)
 * https://zizai-life.test.thinkinpower.net/store/#/rfActivity?isNew=1&rfActivityId=1163   拎包入住/自在驿站活动--url来源：平台后台-活动管理-活动链接 (rfActivity 初始化获取页面详情接口获取communityId存serviceId存sessionStorge， 点击事件将item.serviceId存sessionStorge, 方便后续跳店铺，商品详情)
 * https://zizai-life.test.thinkinpower.net/store/#/goodsDetail?isNew=1&serviceId=413&goodId=352&communityId=1 商品详情页--url来源：商家中心-模板后台-商品管理-上架状态-二维码
 * https://zizai-life.test.thinkinpower.net/store/#/home?isNew=1&serviceId=413&communityId=4 店铺首页--url来源：商家中心-服务管理-我的服务-上架状态-二维码
 * http://t.open.zizai.rfmember.net/static/jump.html?serviceId=894&communityId=1 第三方开发接入服务--url来源：商家中心-服务管理-我的服务-上架状态-二维码
 * https://192.168.197.62:8093/store/#/goodsDetail?isNew=1&serviceId=413&goodId=352&communityId=1
 * https://192.168.197.62:8093/store/#/goodsDetail?isNew=1&serviceId=413&goodId=323 开发链接--商品详情页
 * https://192.168.197.62:8093/store/#/goodsDetail?isNew=1&serviceId=413&communityId=1&goodId=543
 */

Vue.use(Mint)
Vue.use(VueAwesomeSwiper)
Vue.use(VueClipboard)
Vue.use(VueWechatTitle)
let previewOptions = {
  clickToCloseNonZoomable: true
}
Vue.use(preview, previewOptions)

try {
  window.rfReport = new RfReport({
    domain: process.env.VUE_APP_BUILD_TYPE === 'production' ? 'https://act.thinkinpower.com/analytics' : 'https://act.test.thinkinpower.net/analytics',
    isAutoReport: false,
    autoTime: 10 * 1000,
    debugger: process.env.VUE_APP_PROXY_ENV !== 'product',
    isUse: true,
    // ajax请求时需要过滤的url信息
    filterUrl: ['list_user_download', 'rfpay_report/pay/account/list'],
    // 是否上报页面性能数据
    isPage: true,
    // 是否上报ajax性能数据
    isAjax: true,
    // 是否上报页面资源数据
    isResource: true,
    // 是否上报错误信息
    isError: true,
    isDebugger: true,
    // 是否延迟上报
    isDelayReport: true,
    config: {
      app_id: process.env.VUE_APP_BUILD_TYPE === 'production' ? '6a939b24072569d98b2ca0dabd811ca' : 'd057b4686e1c44ff3b9beb15bba21de6',
      module: 'STORE_H5'
    }
  })
} catch (error) {
  console.log('rfReport实例化上报报错====>', error)
}

Vue.component('rf-layout', rfLayout)
Vue.component('rf-Text', rfText)
Vue.component('rf-Flex', rfFlex)
Vue.component('rf-Icon', rfIcon)
Vue.component('rf-Price', rfPrice)
Vue.config.devtools = process.env.NODE_ENV === 'development'
// Vue.config.productionTip = false

// alert(window.location.href)

/* eslint-disable no-new */
// if (process.env.NODE_ENV !== 'production') {
if (process.env.VUE_APP_BUILD_TYPE !== 'production') {
  new VConsole()
}

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
let firstVisit = true

router.beforeEach(async (to, from, next) => {
  console.log('beforeEach', to)
  try {
    window.rfReport.reportData()
  } catch (error) {
    console.log('rfReport路由守卫报错====>', error)
  }

  // 如果有经纬度,则存到 storage 里面
  if ((to.query.latitude && to.query.longitude) || (from.query.latitude && from.query.longitude)) {
    localStorage.setItem('latitude', to.query.latitude)
    localStorage.setItem('longitude', to.query.longitude)
  }

  // 统计每个页面停留时间，埋点等数据
  if (to.path) {
    try {
      // eslint-disable-next-line no-undef
      _hmt.push(['_trackPageview', location.pathname + '#' + to.fullPath])
    } catch (e) { }
  }

  // 设置页面title
  switch (to.name) {
    case 'home':
    case store.state.storeInfo && store.state.storeInfo.tittle:
      // alert(JSON.stringify(store.state.storeInfo.tittle))
      to.meta.title = store.state.storeInfo.tittle
      break
  }
  // 检测无token跳转login, 登录后跳转之前页面
  if (to.name === 'login') {
    let redirectUrl = localStorage.getItem('backUrl')
    // alert(redirectUrl)
    await store.dispatch('GO_TO_LOGIN_NOT_APP', redirectUrl)
    next()
    return
  }

  // 判断该项目是否初始化
  if (firstVisit) {
    firstVisit = false
    // 如果是小程序或者微信，接入微信sdk
    // if (store.state.browser.weChat || window.__wxjs_environment === 'miniprogram') {
    //   try {
    //     let wxInfo = ''
    //     store.dispatch('getWeChatInfo', { params: { url: window.location.href } }).then(async data => {
    //       wxInfo = data.data
    //       // alert(data.data.appId)
    //       const initWxShareParams = { debug: false, appId: wxInfo.appId, timestamp: wxInfo.timestamp, nonceStr: wxInfo.nonceStr, signature: wxInfo.signature }
    //       await store.dispatch('initWxShare', initWxShareParams)
    //     }).catch(e => {
    //       console.log(e, 'form getWeChatInfo')
    //     })
    //     // const shareParams = { icon: location.origin + shareIcon, title: '幸福三重奏', desc: '自在社区贺收楼，三重好礼送不停', descTimeline: '自在社区贺收楼，三重好礼送不停', link: location.href }
    //     // store.dispatch('app/changeWxShare', shareParams)
    //   } catch (e) {
    //     const msg = e.message || e
    //     console.log(msg)
    //   }
    // }
    router.app.$indicator.open()
    if (to.query.from === 'GuanJiaApp') {
      store.commit(types.SET_SDK_DATA, { isApp: true })
      let { access_token: accessToken = '' } = to.query
      if (accessToken) {
        store.commit(types.SET_SDK_DATA, { accessToken: accessToken })
        store.dispatch('SET_ACCESS_TOKEN', accessToken)
      } else {
        // 触发h5 公共页登录页
        await store.dispatch('GET_ACCESS_TOKEN_NOT_APP').catch(msg => {
          console.log('GET_ACCESS_TOKEN_NOT_APP-noApp-flow', msg)
        })
      }
      next()
      return
    }
    try {
      // app 内流程
      console.log('验证是否 app 内流程')
      await store.dispatch('onSdkReady') // 待定删除，确认是否无效方法
      appFlow(to, from, next)
      router.app.$indicator.close()
    } catch (e) {
      // 非app 内流程
      console.log('非app 内流程')
      notAppFlow(to, from, next)
      router.app.$indicator.close()
    }
  } else {
    next()
  }
})

async function bindPopularizeUser (accessToken, popularizeInfo, to, next) {
  try {
    console.log('========================= 绑定运营者 =========================')
    const params = {
      clientType: 'WAP',
      accessToken,
      popularizeInfo
    }
    await store.dispatch('bindPopularizeUser', { params })
    let url = window.location.href
    if (url.indexOf('popularizeInfo') > -1) {
      // delete to.query.popularizeInfo
      firstVisit = true
      // next({
      //   name: to.name,
      //   query: to.query,
      //   params: to.params,
      //   replace: true
      // })
      next(false)
      let abc = url.replace(/popularizeInfo=.*?&/g, '')
      window.location.replace(abc)
      // window.location.replace(url.replace(/popularizeInfo=.*?&/g, ''))
      window.location.reload()
    }
  } catch (error) {
    console.log(error)
  }
}

let setCommAndStoreInfo = false
async function notAppFlow (to, from, next) {
  try {
    // isMiniProgLogin 0 表示小程序环境中未登录， 1 小程序已登录
    // isMiniProgLogin 小程序默认传0，作用：清空H5 URL过期token;
    let { access_token: accessToken = '', isMiniProgLogin = '1' } = to.query
    isMiniProgLogin = parseInt(isMiniProgLogin)
    console.log('accessToken :>>', accessToken)
    console.log('isMiniProgLogin :>>', isMiniProgLogin)
    // 小程序token 校验标志
    if (!isMiniProgLogin) {
      accessToken = ''
      store.dispatch('SET_ACCESS_TOKEN', accessToken)
    }
    // 联登获取token
    if (accessToken) {
      await store.commit(types.SET_SDK_DATA, { accessToken: accessToken })
      // alert('main' + accessToken)
      store.dispatch('SET_ACCESS_TOKEN', accessToken)
      if (to.query.popularizeInfo) {
        await bindPopularizeUser(accessToken, to.query.popularizeInfo, to, next)
        return
      }
    } else {
      try {
        // 触发h5 公共页登录页'
        const token = await store.dispatch('GET_ACCESS_TOKEN_NOT_APP')
        if (to.query.popularizeInfo && token) {
          await bindPopularizeUser(token, to.query.popularizeInfo, to, next)
          return
        }
      } catch (error) {
        console.log('GET_ACCESS_TOKEN_NOT_APP-noApp-flow', error)
      }
    }
  } catch (e) { }

  // 处理非原生app扫码进入页面流程
  if (!setCommAndStoreInfo) {
    setCommAndStoreInfo = true
    // 微信功能初始化
    await WXint()
    let communityId = to.query.communityId || ''

    // 获取社区名
    if (communityId) {
      getCommunityInfo(communityId, 'notAppFlow')
    } else {
      if ((!to.query.latitude || !to.query.longitude) && (!from.query.latitude || !from.query.longitude) && !to.query.communityId && store.state.browser.versions.weChat && window.__wxjs_environment === 'miniprogram') {
        console.log('====================自动获取经纬度====================')
        try {
          router.app.$indicator.open()
          const { latitude, longitude } = await getLocation()
          const params = {
            token: store.state.sdk.accessToken || '',
            longitude: longitude,
            latitude: latitude
          }
          const { data: { cityId = '', cityName = '', id = '', communityName = '' } = {} } = await store.dispatch('getRecentlyCommunity', { params })
          store.dispatch('setCommunityInfo', {
            cityId,
            cityName,
            id,
            name: communityName
          })
          store.commit('SET_COMMUNITY_NAME', communityName)
          store.commit('SET_CITY_ID', [cityId])
          store.commit('SET_CITY_NAME', [cityName])
          router.app.$indicator.close()
          let url = window.location.href
          let queryList = Object.entries(to.query)
          next(false)
          window.location.replace(url + `${queryList.length ? '&' : '?'}communityId=${id}`)
          return
        } catch (error) {
          console.error(error)
        }
      }
    }

    // 页面跳转逻辑
    let query = Object.assign({}, to.query)
    delete query.access_token
    delete to.query.access_token
    next({
      name: to.name,
      query: query,
      params: to.params,
      replace: true
    })
  }
  let query = Object.assign({}, to.query)
  delete query.access_token
  delete to.query.access_token
  next({
    name: to.name,
    query: query,
    params: to.params,
    replace: true
  })
}

async function appFlow (to, from, next) {
  await store.dispatch('checkIfLogin').catch(msg => {
    router.app.$toast({
      duration: 3000,
      message: process.env.NODE_ENV === 'development' ? 'checkIfLogin:' + msg : '' + msg
    })
  })
  let communityId = await store.dispatch('getCommunityId').catch(msg => {
    router.app.$toast({
      duration: 3000,
      message: process.env.NODE_ENV === 'development' ? 'getCommunityId:' + JSON.stringify(msg) : '' + msg
    })
  })

  // 获取社区名
  communityId && getCommunityInfo(communityId, 'appFlow')
  let serviceId = to.query.serviceId
  let accessToken = store.state.sdk.accessToken
  if (serviceId && accessToken && communityId) {
    await getXFSJServiceDetail({
      serviceId,
      accessToken,
      communityId
    })
  }

  let query = Object.assign({}, to.query)
  query.communityId = communityId
  delete query.access_token
  next({
    name: to.name,
    query: query,
    params: to.params,
    replace: true
  })
}

function getLocation () {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      window.wx.getLocation({
        type: 'wgs84',
        success: res => {
          resolve({
            latitude: res.latitude,
            longitude: res.longitude,
            locationType: 'gps'
          })
        },
        fail: reason => {
          console.error(reason)
          reject(new Error('获取定位失败！'))
        }
      })
    }, 1000)
  })
}

function getCommunityInfo (communityId = '', type, to, from, next) {
  let params = {
    community_id: communityId
  }
  store.dispatch('getCommunityInfo', { params }).then(data => {
    store.dispatch('setCommunityInfo', data.data)
    store.commit('SET_COMMUNITY_NAME', data.data.name)
    store.commit('SET_CITY_ID', [data.data.cityId])
    store.commit('SET_CITY_NAME', [data.data.cityName])
    // sessionStorage.setItem('communityId', data.data.id)
  }).catch(msg => {
    if (type === 'notAppFlow') { return null }
    router.app.$toast({
      duration: 3000,
      message: process.env.NODE_ENV === 'development' ? 'getCommunityInfo:' + JSON.stringify(msg) : '' + msg
    })
    next({
      name: 'error',
      query: to.query,
      replace: true
    })
  })
}

function WXint () {
  return new Promise((resolve, reject) => {
    // 微信功能初始化
    let params = {
      url: window.location.href.split('#')[0],
      type: process.env.VUE_APP_BUILD_TYPE === 'production' ? 7 : 4
    }
    store.dispatch('WX_INIT', {
      params: params
    }).then(data => {
      let params = data.data
      // params.debug = process.env.NODE_ENV === 'development'
      store.dispatch('initWxShare', params).then(() => {
        changeWxShare()
      })
      resolve()
    }).catch(msg => {
      router.app.$toast({
        duration: 3000,
        message: process.env.NODE_ENV === 'development' ? 'WX_INIT:' + msg : '' + msg
      })
      reject(msg)
    })
  })
}

// 全局方法，测试环境中toast显示api名称
function ShowApiName (name, msg) {
  return process.env.NODE_ENV === 'development' ? name + ':' + msg : '' + msg
}
Vue.prototype.$ShowApiName = ShowApiName

Vue.prototype.$windowScroll = function () {
  window.scrollTo(0, 1)
}

Vue.prototype.$GetCartNum = function () {
  // 公共方法 获取购物车中商品数量
  let params = {}
  params.clientType = 'WAP'
  params.access_token = this.$getAccessTokenFromStorage()
  store.dispatch('getCartNum', {
    params: params
  }).then(data => {
    store.state.cartNum = data.data
  }).catch(reason => {
    if (reason.name && reason.message) {
      let msg = reason.message ? reason.message : reason
      router.app.$toast({
        duration: 3000,
        message: process.env.NODE_ENV === 'development' ? 'getCartNum:' + msg : '' + msg
      })
    }
  })
}

Vue.prototype.$ValidateToken = function () {
  // 公共方法 校验token
  let params = {}
  params.accessToken = this.$getAccessTokenFromStorage()
  store.dispatch('validateToken', { params })
}

let scrollEnable = true
Vue.prototype.$Scroll = function (elName, fun) {
  if (!scrollEnable) {
    return
  }
  const el = document.getElementById(elName)
  const scrollHeight = el.scrollHeight
  const currentScroll = el.scrollTop
  const clientHeight = el.clientHeight
  // console.log(el.scrollHeight, 'scrollHeight')
  // console.log(el.scrollTop, 'scrollTop')
  // console.log(el.clientHeight, 'clientHeight')
  // console.log(currentScroll + clientHeight - scrollHeight * 0.8)
  if ((currentScroll + clientHeight) >= (scrollHeight * 0.8)) {
    if (scrollEnable) {
      scrollEnable = false
      setTimeout(() => {
        fun()
        scrollEnable = true
      }, 500)
    }
  }
}

/**
 * 百度坐标系 (BD-09) 与 火星坐标系 (GCJ-02)的转换
 * 即 百度 转 谷歌、高德
 * @param bdLon
 * @param bdLat
 * @returns {*[]}
 */
Vue.prototype.$DbToGc = (bdLon, bdLat) => {
  let xPi = 3.14159265358979324 * 3000.0 / 180.0
  let x = bdLon - 0.0065
  let y = bdLat - 0.006
  let z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * xPi)
  let theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * xPi)
  let ggLng = z * Math.cos(theta)
  let ggLat = z * Math.sin(theta)
  return [ggLng, ggLat]
}

Vue.prototype.$DeleteQueryFromUrlHash = (url, queryName) => {
  let urlObj = {}
  try {
    urlObj = new window.URL(url)
    if (urlObj.hash.match(/\?/)) {
      const hashArr = urlObj.hash.split('?')
      const queryArr = hashArr[1].split('&')
      let queryArrNew
      if (toString.call(queryName) === '[object String]') {
        queryArrNew = queryArr.filter(query => !query.match(queryName))
      } else if (toString.call(queryName) === '[object Array]') {
        // queryArrNew = queryArr.filter(query => !queryName.includes(query))
        queryArrNew = queryName.reduce((acc, cur) => {
          acc = acc.filter(query => !query.match(cur))
          return acc
        }, queryArr)
      }
      urlObj.hash = hashArr[0] + '?' + queryArrNew.join('&')
    }
  } catch (e) { }
  return urlObj.href || url
}
Vue.prototype.$DeleteQueryFromUrlSearch = (url, queryName) => {
  let urlObj = {}
  try {
    urlObj = new window.URL(url)
    if (urlObj.search.match(/\?/)) {
      const searchArr = urlObj.search.split('?')
      const queryArr = searchArr[1].split('&')
      const queryArrNew = queryArr.filter(query => !query.match(queryName))
      urlObj.search = searchArr[0] + '?' + queryArrNew.join('&')
    }
  } catch (e) { }
  return urlObj.href || url
}
Vue.prototype.$errorFormatter = errorFormatter

function changeWxShare () {
  let shareParams = {
    title: store.state.storeInfo.share.title,
    desc: store.state.storeInfo.share.desc,
    icon: store.state.storeInfo.share.icon,
    link: store.state.storeInfo.share.link,
    descTimeline: store.state.storeInfo.share.descTimeline
  }
  store.dispatch('changeWxShare', shareParams)
}

function getXFSJServiceDetail ({
  serviceId,
  accessToken,
  communityId
}) {
  let params = {
    serviceId,
    access_token: accessToken,
    communityId
  }
  return store.dispatch('getXFSJServiceDetail', {
    params
  }).then(data => {
    let serviceId = data.data.serviceId || ''
    let developType = data.data.developType || ''
    let templeteName = data.data.templeteName || ''
    let templeteStatus = data.data.templeteStatus || ''
    store.dispatch('setServiceInfo', {
      serviceId,
      developType,
      templeteName,
      templeteStatus
    })
    // alert('main')
  }).catch(reason => {
    let msg = reason.message ? reason.message : reason
    // 商品详情隐藏对token 的校验提示
    if (msg === '请登录') {
      return
    }
    router.app.$toast({
      duration: 3000,
      message: process.env.NODE_ENV === 'development' ? 'getXFSJServiceDetail:' + msg : '' + msg
    })
  })
};

// 获取accessToken公共方法
Vue.prototype.$getAccessTokenFromStorage = function () {
  let accessToken = store.state.sdk.accessToken
  if (accessToken) {
    return accessToken
  }
  return false
}

// Vue.prototype.$env = process.env.BUILD_MODE

const evt = document.createEvent('HTMLEvents')
evt.initEvent('hashchange', true, true)
router.afterEach((to, from) => {
  // 加载后页面，滚动条最上
  window.scrollTo(0, 1)
  if (to.meta.title) {
    document.title = to.meta.title
  }
  window.dispatchEvent(evt)
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
